/* Keep the store badge off the primary image's network/paint path. */
(function () {
  'use strict';
  var config = document.querySelector('[data-store-widget-config]');
  if (!config || document.getElementById('merchantWidgetScript')) return;
  var options;
  try { options = JSON.parse(config.textContent); } catch (_) { return; }
  var started = false;
  var delayTimer = 0;
  var interactionEvents = ['pointerdown', 'keydown', 'scroll'];
  function stopInteractionWatch() {
    interactionEvents.forEach(function (eventName) {
      window.removeEventListener(eventName, loadAfterInteraction);
    });
  }
  function load() {
    if (started || document.getElementById('merchantWidgetScript')) return;
    started = true;
    if (delayTimer) window.clearTimeout(delayTimer);
    stopInteractionWatch();
    var script = document.createElement('script');
    script.id = 'merchantWidgetScript';
    script.src = 'https://www.gstatic.com/shopping/merchant/merchantwidget.js';
    script.async = true;
    script.addEventListener('load', function () {
      if (window.merchantwidget) window.merchantwidget.start(options);
    }, { once: true });
    document.head.appendChild(script);
  }
  function loadWhenIdle(timeout) {
    if ('requestIdleCallback' in window) window.requestIdleCallback(load, { timeout: timeout });
    else window.setTimeout(load, 0);
  }
  function loadAfterInteraction() {
    stopInteractionWatch();
    loadWhenIdle(1200);
  }
  function afterPaint() {
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        if (started) return;
        delayTimer = window.setTimeout(function () { loadWhenIdle(1500); }, 10000);
      });
    });
  }
  function ready() {
    var primary = document.querySelector('[data-home-hero-slide].is-active img, img[fetchpriority="high"][loading="eager"]');
    if (!primary || primary.complete) { afterPaint(); return; }
    function settled() {
      primary.removeEventListener('load', settled);
      primary.removeEventListener('error', settled);
      afterPaint();
    }
    primary.addEventListener('load', settled);
    primary.addEventListener('error', settled);
  }
  interactionEvents.forEach(function (eventName) {
    window.addEventListener(eventName, loadAfterInteraction, { once: true, passive: true });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, { once: true });
  else ready();
}());
